/**
 * Establecer datos para las listas.
 *
 * @param {*} state
 * @param {*} nextLists
 * @author Fernando CLaros Garcia
 */
export function setLists(state, nextLists) {
  state.lists = nextLists;
}

/**
 * Establecer lista encontrada.
 *
 * @param {*} state
 * @param {*} list
 * @author Paul Valencia
 */
export function setSysList(state, list) {
  state.list = list;
}
